import { ChevronRight } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import get from 'lodash/get'
import CustomMaterialTableWrapper from 'src/components/CustomMaterialTableWrapper/CustomMaterialTableWrapper'
import ColoredTooltip from 'src/components/Tooltip/ColoredTooltip'
import { DelIntelThemeGroupby } from 'src/services/openApiV2'
import { formatCurrency, formatNumber } from 'src/utils/functions'
import ErrorInsightsThemeDrawer from '../Drawer/ErrorInsightsThemeDrawer'

interface ErrorInsightsTableProps {
  themesData: DelIntelThemeGroupby[]
  themesDataLoading: boolean
  selectedTheme: DelIntelThemeGroupby | null
  onClick: (theme: string) => void
}

const ErrorInsightsTable = ({ themesData, themesDataLoading, selectedTheme, onClick }: ErrorInsightsTableProps) => {
  return (
    <>
      <ErrorInsightsThemeDrawer
        errorTheme={selectedTheme}
        onClose={() => onClick(null)}
      />

      <CustomMaterialTableWrapper
        isLoading={themesDataLoading}
        data={themesData}
        columns={[
          {
            title: 'Error Theme',
            field: 'theme',
            render: (data) => {
              return (
                <ColoredTooltip
                  title="See all orders with this error"
                  arrow>
                  <Button
                    variant="text"
                    endIcon={<ChevronRight sx={{ height: '20px' }} />}
                    sx={{
                      width: 'fit-content',
                      borderRadius: '2px',
                      backgroundColor: '#f3f3f3',
                      color: '#000',
                      justifyContent: 'space-between',
                      maxWidth: '400px',
                      p: '8px 10px',
                      '&:hover': {
                        bgcolor: '#e8e8e8',
                        color: '#000'
                      }
                    }}>
                    <Typography
                      fontSize="12px"
                      fontWeight={600}
                      lineHeight="initial"
                      textAlign="left"
                      style={{
                        color: '#000'
                      }}
                      noWrap>
                      {get(data, 'theme', undefined)}
                    </Typography>
                  </Button>
                </ColoredTooltip>
              )
            }
          },
          {
            title: 'Error Charge',
            field: 'error_charge',
            render: (data) => {
              return (
                <Typography
                  fontSize="13px"
                  color="#E52E2E">
                  {formatCurrency(get(data, 'error_charge', 0), { maxFractionDigits: 2 })}
                </Typography>
              )
            }
          },
          {
            title: 'Error Charge Contribution',
            field: 'error_charge_contribution',
            render: (data) => {
              return (
                <Typography
                  fontSize="13px"
                  color="#000">
                  {formatNumber(get(data, 'error_charge_contribution', 0) * 100, { maxFractionDigits: 2 })}%
                </Typography>
              )
            }
          },
          {
            title: 'Percentage of Cases',
            field: 'instances_contribution',
            render: (data) => {
              return (
                <Typography
                  fontSize="13px"
                  color="#000">
                  {formatNumber(get(data, 'instances_contribution', 0) * 100, { maxFractionDigits: 2 })}%
                </Typography>
              )
            }
          }
        ]}
        options={{
          search: true,
          export: true,
          sortable: true,
          initialSortableOption: 'error_charge_contribution',
          initialOrderBy: 'descending'
        }}
        onRowClick={(data) => {
          onClick(data.theme)
        }}
      />
    </>
  )
}

export default ErrorInsightsTable
